export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procurar"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Você está no modo Demo. Os saldos e as operações são de treinamento."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ir para o gabinete de trabalho"])}
}